import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import profile from "../../../images/profile/pic1.jpg";
import { useSelector } from "react-redux";
import { NavMenuToggle } from "./NavHader";

const Header = ({ onNote }) => {
	const authUser = useSelector((state) => state.auth.authUser);

	//For fix header
	const [headerFix, setheaderFix] = useState(false);
	useEffect(() => {
		const handleScroll = () => setheaderFix(window.scrollY > 50);
		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	const { pathname } = useLocation();
	const path = pathname.split("/");
	const name = path[path.length - 1].split("-");
	const filterName = name.length >= 3 ? name.filter((n, i) => i > 0) : name;

	const finalName = path.includes("admin-details") ? ["Organization"]
		: path.includes("team-details") ? ["Team Overview"]
		: path.includes("manage-exec-admins") ? ["Manage Executive Admins"]
		: path.includes("chart-of-accounts") ? ["Chart of Accounts"]
		: path.includes("roles-and-permissions") ? ["Roles & Permissions"]
		: path.includes("user-wallet-balances") ? ["User Wallet Balances"]
		: path.includes("my-expense-tag-stats") ? ["Mili Insights"]
		: path.includes("top-up-reconciliation") ? ["Vault Top-Up Reconciliation"]
		: path.includes("sign-in-activity") ? ["Sign-in Activity"]
		: path.includes("users") ? ["Users"]
	: path.includes("expense-tag-stats") ? ["Insights"]
		: filterName;

	return (
		<div className={`header ${headerFix ? "is-fixed" : ""}`} style={{ backgroundColor: "#fff" }}>
			<div className="header-content">
				<nav className="navbar navbar-expand">
					<div className="collapse navbar-collapse justify-content-between">
						<div className="header-left d-flex align-items-center">
							<button
								type="button"
								className="header-mini-toggle"
								aria-label="Toggle sidebar labels"
								onClick={NavMenuToggle}
								data-tour="apps-menu-toggle"
							>
								<svg width="20" height="20" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
									<rect x="22" y="11" width="4" height="4" rx="2" />
									<rect x="11" width="4" height="4" rx="2" />
									<rect x="22" width="4" height="4" rx="2" />
									<rect x="11" y="11" width="4" height="4" rx="2" />
									<rect x="11" y="22" width="4" height="4" rx="2" />
									<rect width="4" height="4" rx="2" />
									<rect y="11" width="4" height="4" rx="2" />
									<rect x="22" y="22" width="4" height="4" rx="2" />
									<rect y="22" width="4" height="4" rx="2" />
								</svg>
							</button>
							<div
								className="dashboard_bar"
								style={{ textTransform: "capitalize" }}
							>
								{/* TODO: figure out dark mode */}
								{finalName.join(" ").length === 0
									? "Dashboard"
									: finalName.join(" ") === "dashboard dark"
										? "Dashboard"
										: finalName.join(" ")}
							</div>
						</div>
						<div className="navbar-nav header-right">
							<div className="dz-side-menu">
								<div className="search-coundry d-flex align-items-center">
								</div>
								<ul>
									<li className="nav-item">
										<Link
											to="/user-profile"
											className="header-profile-button d-inline-flex align-items-center"
												style={{ maxWidth: "min(12rem, calc(100vw - 6rem))", minWidth: 0, gap: "0.5rem", overflow: "hidden" }}
											aria-label={`Open ${authUser?.preferred_name || authUser?.first_name || 'your'} profile`}
											title={authUser?.preferred_name || authUser?.first_name || 'Your profile'}
										>
											<img
												src={profile}
												className="header-profile-avatar flex-shrink-0"
												alt=""
											/>
											{(authUser?.preferred_name || authUser?.first_name) && (
												<span
													className="header-profile-name d-inline-block d-sm-none"
												>
													{(() => {
														const n = authUser?.preferred_name || authUser?.first_name || '';
														return n.length > 7 ? n.slice(0, 7) + '…' : n;
													})()}
												</span>
											)}
											{(authUser?.preferred_name || authUser?.first_name) && (
												<span
													className="header-profile-name text-truncate d-none d-sm-inline-block"
													style={{ minWidth: 0 }}
												>
													{authUser?.preferred_name || authUser?.first_name}
												</span>
											)}
										</Link>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</nav>
			</div>
		</div>
	);
};

export default Header;
